import { Component,Input, SimpleChange, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Api } from '../../Model/api-model';
import {RestApiService} from '../../Services/rest-api-service';
import { AppListResponse } from 'src/app/Model/apilistresponse-model';
import {createapp,createappResponse} from '../../Model/createappRequest-model';
import {Message,MessageService} from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import { App, SmartApp } from 'src/app/Model/app-model';
import { ProductList } from 'src/app/Model/productList-model';
import { Product, ProductPlan, Plan, MySubResponse, MySubscriptions, Subscription, SubscriptionList } from 'src/app/Model/product-model';
import { environment } from '../../../environments/environment';
import { timer } from 'rxjs';
import { delay } from 'rxjs/operators';
@Component({
  selector: 'app-products',
  templateUrl: './product.component.html'
})
export class ProductComponent implements OnChanges{
  publicProductList:ProductList;
  products:Product[];
  selectedProduct:Product;
  productListCols:any[];
  plans:ProductPlan;
  apisPlan:Plan[];
  apisPlanCols:any[];
  loadAppRequest:boolean=false;
  subsriptionerrorToastmessage:string;
  subsribeconfirmationPopup:boolean;
  subsriptionPlan:string;
  sendEmailNotification=false;
  isSandboxtoProdMove=false;
  msgs: Message[] = [];
   @Input() appName:string;
   @Input() appCallBackUrl:string;
   @Input() appID:string;

   @Input() pathInfo:string;
   showSpiner:boolean=false;
   @Input()  showDivOfPrd:boolean;
   displayPlanName:string;
   regionLabel;
  isMailToBusinessForSandboxApproval=false;
  roleValue='0';
displayRole;

appList:AppListResponse=new AppListResponse();

isAllSelected;
   constructor(private router: Router,private restApi: RestApiService,private messageService:MessageService) {
      this.displayPlanName=environment.getPlanName();
     // console.log("plan name "+this.displayPlanName);
     this.regionLabel = environment.getEnvironment();
  }
  changeProdSelectionStatus(){


     if(this.isAllSelected){
                 
         
           for(let pdnv of this.products){

               pdnv.isSelected=true;
            }
     }else{
                       
      
      for(let pdnv of this.products){

        pdnv.isSelected=false;
        }

     }


  }


  ngOnInit() {
      this.loadAppRequest=true;
      this.productListCols = [
        { field: 'productName', header: 'Product Name' },
        { field: 'productID', header: 'Product ID' },
        { field: 'version', header: 'Version' }
        
    ];
    this.apisPlanCols = [
      { field: 'path', header: 'APIs' }
     
      
  ];
 //   this.publicProducts();

  }




showSubNowButton=false;

  publicProducts() {
    this.showSubNowButton=false;
    this.showDivOfPrd=true;
    return this.restApi.getPublicProducts().subscribe((data: {}) => {
      //this.appList = data;
     // console.log("product List"+data); 
      this.publicProductList=data as ProductList;
       this.products=this.publicProductList.productListView;
 
         for(let pdnv of this.products){

              
              if(this.alreadySubProducts.includes(pdnv.productID)){
                pdnv.categories='na';
              }
         }

         let tempRole=localStorage.getItem("roleValue");

        let compareRole;

        if(tempRole=='1'){
          compareRole='p2p';
        }else if(tempRole=='0'){
          compareRole='developer';
        }
        else if(tempRole=='3'){
          compareRole='provider';
        }

        
        else{
          compareRole='broker';
        }

        console.log("compare role "+compareRole)

         for(let pdnv of this.products){

          console.log("pdnv.categories "+pdnv.categories)
              if(pdnv.categories.includes(compareRole)){
                this.showSubNowButton=true;
              }
       }

       this.products.sort((a: Product, b: Product) => {
        return a.productName.localeCompare(b.productName);
    });



    this.showPublicProducts=true;

       this.loadAppRequest=false; 
    },(error)=>{
      this.loadAppRequest=false;

      this.showPublicProducts=true;
      // console.log(error);
    })
  }
  finalStatusBAr=false;
  viewApisOfProduct;
  viewApis(product:Product){
    this.msgs=[];
    this.selectedProduct=product;
     this.viewApisOfProduct=false;
     this.finalStatus=false;
     this.finalStatusBAr=true;  

     const env=localStorage.getItem("path");
     if(product.productName.includes('patientaccess') && env=="production"){
          this.displayPlanName="Gold";
     }
     else{

            
                  if(product.productName.includes('payertopayerapi') && env=="production"){
                    this.displayPlanName="Gold";
                  }
                  else{


                    this.displayPlanName=environment.getPlanName();

                   }
     }
       // console.log("data ger");
    // console.log("productID"+this.selectedProduct.productID);

     this.publicProductsInfo(this.selectedProduct.productID);

  }
  subscribeConfirmation(plan:string){

    let tempRole=localStorage.getItem("roleValue");

    let compareRole;

    if(tempRole=='1'){
      compareRole='p2p';
    }else if(tempRole=='0'){
      compareRole='developer';
    }
    else if(tempRole=='3'){
      compareRole='provider';
    }
    
    else{
      compareRole='broker';
    }

       let  checkIfSelected=false;

      for(let pdnv of this.products){

        if(pdnv.isSelected && pdnv.categories.includes(compareRole)){
                   checkIfSelected=true;
        
          }
      }

      if(!checkIfSelected){
        
      alert("Please select at least one product.");
             return;

      }


   this.subsriptionPlan = plan;
    this.subsribeconfirmationPopup=true;
    //this.disable_updateappbutton();
  }
  subscribecancelConfirmation(){
    this.subsribeconfirmationPopup=false;
    //this.enable_updateappbutton();
  }


  mySubscriptionForCheck(){
    // console.log("here we are")
     return this.restApi.mySubscription().subscribe(async (data: {}) => {
     //   console.log(data);   
       this.subscriptionList=data as MySubscriptions;
       this.subscription=this.subscriptionList.subscription;
    
      const appid=this.appID;
      const product=this.selectedProduct.productName;
      const productVersion=this.selectedProduct.version;
      const env=localStorage.getItem("path");
      // console.log("prodcut "+product);
     //console.log("app name "+appid)
     
    // console.log("region "+env)

       let subFlag=true;


       
        

       if(env=='production'){
        this.sendEmailNotification=true;
       }

      let tempRoleValue= localStorage.getItem("roleValue");
      
      for(const sub of this.subscription){
         
    
        if(localStorage.getItem("my_smart_App")){
            this.GetRole_FromLocalApp(sub.appId);

          }

        else{

            await this.loadSmartAppFlag(sub.appId);
         }

       if(tempRoleValue==this.roleValue){
       
        console.log("selected env out loop"+env)

        console.log("selected env role"+this.roleValue)

                  if(env=='production'){
                  
                          if(sub.environment.includes('production') && (sub.subscriptionApproved)){
                            console.log("inside prod alreday approved")
                            this.sendEmailNotification=false;
                          }//end of if for inner email notification

                    }//end of if upper email notification

                if(sub.environment.includes('sandbox') && (sub.subscriptionApproved))
                {
                     
                
                  this.isSandboxtoProdMove=true;
                }




              if(sub.environment==env && sub.appId==appid && sub.productName==product && sub.productVersion==productVersion){
              
                   subFlag=false;
                }//end of if


               } //end of if for role check 
           }//end of for
    

           if(subFlag){
              this.subscribeNow();
            
             }else{
              
              this.showSpiner=false;
              this.msgs.push({severity:'error',detail:"You already have a subscription for this app for same product."});
         
                }



          },(error)=>{
      
            this.showSpiner=false;
     })
   }




  subscribeNowCheck(){
 
    this.subsribeconfirmationPopup=false;
    this.showSpiner=true;
      this.mySubscriptionForCheck();

     
  }

  async subscribeNowMultipleProducts(){
 
    this.subsribeconfirmationPopup=false;
    this.showSpiner=true;

    let tempRole=localStorage.getItem("roleValue");

  

    let compareRole;

    if(tempRole=='1'){
      compareRole='p2p';
    }else if(tempRole=='0'){
      compareRole='developer';
    }
    else if(tempRole=='3'){
      compareRole='provider';
    }
    
    else{
      
      compareRole='broker';
    }

   

     let inverval_timer = setInterval(() => {
       
        console.log("1 seconds completed");


      let killInterval=true;      

        for(let pdnv of this.products){

          if(pdnv.isSelected && pdnv.categories.includes(compareRole)){
    
            this.showPublicProducts=false;        
             
            killInterval=false;
    
             console.log("trigger now "+new Date())
              this.subscribeNowMultipleOptions(pdnv.productID);
            
            pdnv.isSelected=false;

            break;
         
    
    
          }
        }

      if(killInterval){
        clearInterval(inverval_timer); 
      }

    }, 1000);


  

   
   
    this.showSpiner=true;



    setTimeout(() => {
      console.log('sleep');

      //this.showSpiner=false;
      this.router.navigate(['product-subscription-status']);
    }, 15000);


      
    
   // this.msgs.pop();


   //  this.msgs.push({severity:'info',detail:'Your request has been successfully submitted. System will take 5–10 minutes to reflect subscription changes. '+""});   
    
    

     
  }


  subscribeNow(){
   this.subsribeconfirmationPopup=false;
  // console.log("plan is "+this.subsriptionPlan)
   //console.log("appid "+this.appID)
  // console.log("product id "+this.selectedProduct.productID)
   this.showSpiner=true;
   const reqBody={"plan":this.subsriptionPlan,"productId":this.selectedProduct.productID};
   this.showDivOfPrd=false;

   return this.restApi.doSubscriptionForAnApp(this.appID,reqBody).subscribe((data: {}) => {
    //this.appList = data;
    this.showSpiner=false;
    const temp=data as MySubResponse;
   // console.log("status is "+temp.status)
    
   console.log("this.sendEmailNotification "+this.sendEmailNotification)
   console.log("this.isSandboxtoProdMove "+this.isSandboxtoProdMove)
     if(temp.status==="Success"){
      
         if(this.sendEmailNotification && this.isSandboxtoProdMove){
            this.sendEmailToBuinessForVetting();
          }
  
           if(this.isMailToBusinessForSandboxApproval){
            this.sendEmailToBuinessForProdtoSandboxMove();
           }

      this.router.navigate(['subscriptionstatus']);
      this.msgs.pop();
      this.msgs.push({severity:'info',detail:'You have successfully subscribed this plan for this App '+this.appName +""});   
     }else{
      const obje_Json=JSON.parse(temp.errorMessage);
      //var s=Object.values(obje_Json.errors[0]);
      //this.subsriptionerrorToastmessage = s.toString();
      //var Error_string=obje_Json.errors[0]["apps.name.conflict"];
      const Error_string=obje_Json.errors[0]["apps.subscriptions.conflict"];
    //  this.subsriptionerrorToastmessage = Error_string.toString();
     // this.subsriptionerrorToastmessage = Error_string;
        if(Error_string !=null && Error_string!=""){

          this.subsriptionerrorToastmessage = Error_string.toString();
        }else{

         
          const Error_string=obje_Json.errors[0]["apps.subscriptions.conflictProduct"];
         
          this.subsriptionerrorToastmessage= Error_string.toString();
        }

     // console.log(this.subsriptionerrorToastmessage);
      this.msgs.pop();
      this.msgs.push({severity:'error',detail:this.subsriptionerrorToastmessage});  
     } 
    
   
  },(error)=>{
    this.showSpiner=false;
    // console.log(error);
  })


 }

 async subscribeNowMultipleOptions(productID){
  this.subsribeconfirmationPopup=false;
 // console.log("plan is "+this.subsriptionPlan)
  //console.log("appid "+this.appID)
 // console.log("product id "+this.selectedProduct.productID)
//  this.showSpiner=true;
  const reqBody={"plan":'default',"productId":productID};
  this.showDivOfPrd=false;

  

  return this.restApi.doSubscriptionForAnApp(this.appID,reqBody).subscribe((data: {}) => {
   //this.appList = data;
  // this.showSpiner=false;
   const temp=data as MySubResponse;
  // console.log("status is "+temp.status)
   
 
     
   
  
 },(error)=>{
   this.showSpiner=false;
   // console.log(error);
 })


}

 goToProducats(){


   
  let top = document.getElementById('productsscroll');
  if (top !== null) {
    top.scrollIntoView();
    top = null;
  }
 }
  goToMyApp(){


   
    let top = document.getElementById('myappviewscroll');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  


}


  publicProductsInfo(productId:string) {
    return this.restApi.getProductInfo(productId).subscribe((data: {}) => {
      //this.appList = data;
      this.plans=data as ProductPlan;
      this.apisPlan=this.plans.plans;
      this.viewApisOfProduct=false; 

      let top = document.getElementById('subviescroll');
      if (top !== null) {
        top.scrollIntoView();
        top = null;
      }

      this.finalStatus=true;
      this.finalStatusBAr=false;


     // this.mySubscription();
    },(error)=>{
      
     //  console.log(error);
    })
  }

finalStatus=false;
  subscriptionList:MySubscriptions;
   subscription:Subscription[];
    mySubscription(){
    // console.log("here we are")
     return this.restApi.mySubscription().subscribe(async (data: {}) => {
     //   console.log(data);   
       this.subscriptionList=data as MySubscriptions;
       this.subscription=this.subscriptionList.subscription;
     //  console.log(this.subscription); 
     let sandboxStatusVetting=false;
     let prodStatusVetting=false;
     this.isMailToBusinessForSandboxApproval=false;

    let tempRoleValue= localStorage.getItem("roleValue");







    

    let count=1;
      for(const sub of this.subscription){
        
       

    
        if(localStorage.getItem("my_smart_App")){
  
            
          this.GetRole_FromLocalApp(sub.appId);

        }

        else{

          console.log("again going for smart app call "+this.roleValue)
          console.log("logging before wait");
          await this.loadSmartAppFlag(sub.appId); // again going for smart app call

          console.log("logging after wait "+this.roleValue);
         }
   

        

        

        if(tempRoleValue==this.roleValue){

          console.log("role got matched with temp role "+this.roleValue)
                        if(sub.subscriptionApproved==true && sub.environment=='sandbox'){
                        
                          sandboxStatusVetting=true;
                         
                        } //end of sandbox if
                        if(sub.subscriptionApproved==true && sub.environment=='production'){
                            prodStatusVetting=true;
                           
                        }  //end of producation if


          }//end of role if

           console.log("loop count "+count)
        

           count=count+1;
       }//end of for
    
      if(localStorage.getItem("path")=="production" && prodStatusVetting){
         this.displayPlanName="default";
      }
   
      if(localStorage.getItem("path")=="sandbox" && sandboxStatusVetting){
        this.displayPlanName="default";
      }
      
      if(localStorage.getItem("path")=="sandbox" && prodStatusVetting){
        this.displayPlanName="default";
         
        if(!sandboxStatusVetting){
    
          this.isMailToBusinessForSandboxApproval=true;
          
         }

      }
     
      localStorage.setItem("stat",this.displayPlanName);

      this.finalStatus=true;
      this.finalStatusBAr=false;
     },(error)=>{
      
     })
   }


   GetRole_FromLocalApp(subAppID){

    let myAPP=localStorage.getItem("my_smart_App");
                    
    // console.log("parsing json "+myAPP)
      this.appList.appListView= JSON.parse(myAPP) as App[];

      for(let myapp of this.appList.appListView){

        let appId=myapp.appID;
         
         if(appId==subAppID){
           this.roleValue=myapp.roleValue;
          console.log("role value from local "+this.roleValue)
           console.log("got match from local storage");
         }//end of if
      }// end of for loop for local storage of my app

   }




  async loadSmartAppFlag(appID){

    console.log("logging before entering method");
     return this.restApi.getSmartAppFlag_promise(appID).then(( data: {}) => {
   
        //console.log("samrt app "+data.payerFlag)
        console.log("logging inside repose of of smart app details");
          let  ResponseApp= data as SmartApp;
  
           this.roleValue= ResponseApp.payerFlag;

           if(this.roleValue==""){

            this.roleValue= '0';     
           }
           console.log("respinse of smart app api"+ResponseApp.payerFlag);
  
             
      },(error)=>{
  
        console.log("logging inside error of of smart app details");
        this.roleValue= '0';
      })


      console.log("return back to main method");
  
  }
  





  sendEmailToBuinessForVetting(){

    console.log("sending emails-------------------------------"+environment.getEmailDL())
    let htmlBodyB="<style>table, th, td {border: 1px solid black;border-collapse: collapse;}th, td {padding: 5px;}th {text-align: left;}</style><br><p>Hi,<br/>Sandbox approved user noted below has created an application and subscribed to a production API. Please perform appropriate behavior vetting.</p><br><table style='width:80%'><tr><th>User Name</th><th>Email Address</th><th>Application Name</th><th>Product Subscribed</th></tr><tr><td>"+localStorage.getItem("firstName")+" "+localStorage.getItem("lastName")+"</td><td> <u>"+localStorage.getItem("email_ID")+"</u> </td><td>"+this.appName+"</td><td>"+this.selectedProduct.productName+"</td></tr></table>";
    let toB=environment.getEmailDL();
    let fromB="APICDevportal@AETNA.com";
    let subjectB="Automated Email: Approved Sandbox user requiring Production behavior vetting("+this.regionLabel+")";
    let request={from:fromB,to:toB,htmlBody:htmlBodyB,subject:subjectB,bcc:'NA',cc:'NA'};
      return this.restApi.emailTrigger(request).subscribe((data: {}) => {
       
      },(error)=>{
        
       //  console.log(error);
      })

  }


  sendEmailToBuinessForProdtoSandboxMove(){

    console.log("sendEmailToBuinessForProdtoSandboxMove-------------------------------"+environment.getEmailDL())
    let htmlBodyB="<style>table, th, td {border: 1px solid black;border-collapse: collapse;}th, td {padding: 5px;}th {text-align: left;}</style><br><p>Hi,<br/>Production approved user has created an application and subscribed to one or more sandbox APIs and has been auto approved. Please update QuickBase accordingly.</p><br><table style='width:80%'><tr><th>User Name</th><th>Email Address</th><th>Application Name</th><th>Product Subscribed</th></tr><tr><td>"+localStorage.getItem("firstName")+" "+localStorage.getItem("lastName")+"</td><td> <u>"+localStorage.getItem("email_ID")+"</u> </td><td>"+this.appName+"</td><td>"+this.selectedProduct.productName+"</td></tr></table>";
    let toB=environment.getEmailDL();
    let fromB="APICDevportal@AETNA.com";
    let subjectB="Update QuickBase for Production User Who is Auto Approved for Sandbox("+this.regionLabel+")";
    let request={from:fromB,to:toB,htmlBody:htmlBodyB,subject:subjectB,bcc:'NA',cc:'NA'};
      return this.restApi.emailTrigger(request).subscribe((data: {}) => {
       
      },(error)=>{
        
       //  console.log(error);
      })

  }





  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    //this.childFunction();
   // console.log("selected app "+this.appID);

    let tempRole=localStorage.getItem("roleValue");

    if(tempRole=='1'){
      this.displayRole='p2p';
    }else if(tempRole=='0'){
      this.displayRole='developer';
    }
    
    else if(tempRole=='3'){
      this.displayRole='apigee-provider';
    }
    
    else{
      this.displayRole='broker';
    }



   this.viewApisOfProduct=true;
   
    this.mySubscriptionForAnApp();

   this.msgs=[];
   
  }

  ngAfterViewChecked(){
    document.querySelectorAll('table')
    .forEach((input) => {
 //     console.log(input.getAttribute("role"));
       if(input.getAttribute("role")=="grid"){
        input.removeAttribute("role");
       }
     
    });

  }


  subscriptionListForAnApp:SubscriptionList;
  subscriptionForAnApp:Subscription[];


 
  alreadySubProducts="start";

  showPublicProducts=false;

  mySubscriptionForAnApp(){
    // console.log("here we are")
   
    this.loadAppRequest=true;

    this.showPublicProducts=false;
    return this.restApi.mySubscriptionForAnApp(this.appID).subscribe((data: {}) => {
   
      this.subscriptionListForAnApp=data as SubscriptionList;
      this.subscriptionForAnApp=this.subscriptionListForAnApp.subsApiVO;
  
   
   
      for(const sub of this.subscriptionForAnApp){
         
        this.alreadySubProducts=this.alreadySubProducts+sub.productID;
        
      
       }//end of for

     console.log("alreday sub products "+this.alreadySubProducts)
     
     this.publicProducts();
    
     },(error)=>{

     })
   }


}

